<div
  class="orgApp-prompt-dialog-container orgApp-d-flex orgApp-flex-dir-col orgApp-align-i-center orgApp-gap-16"
  [ngClass]="{
    'orgApp-warning-dialog': data.iconName === 'warning','orgApp-review-delete-pool-prompt' : data.customNotifyPoolClass 
  }"
>
  <div class="orgApp-prompt-dialog-close-button-div">
    <button
      type="button"
      mat-icon-button
      class="orgApp-prompt-dialog-close-button"
      (click)="onNoClick()"
    >
    <svg width="24" height="24">
      <use xlink:href="#close-icon"></use>
    </svg>
    </button>
  </div>
  <div
    class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-16 orgApp-align-i-center"
  >
    @if(data.iconName){
      <svg width="56" height="56">
        <use [attr.xlink:href]="'#orgApp-' + data.iconName"></use>
      </svg>
    }
    <div>
      <h3
        mat-dialog-title
        class="orgApp-prompt-dialog-title orgApp-d-flex orgApp-justify-c-center"
      >
        {{ data.title | translate }}
      </h3>
    </div>
    <mat-dialog-content
      class="orgApp-gap-16 orgApp-text-center orgApp-prompt-dialog-sub-title"
    >
      <p>
        {{ data.message | translate: (data.translationParams ? data.translationParams : {}) }}
        @if(data.unmappedMembers){
        <span>{{ data.unmappedMembers }}.</span>
        } @if(data.monthName){
        <span>{{ data.monthName | translate }}</span>
        } @if(data.year){
        <span> {{ data.year }}</span>
        } @if(data.msg1){
        {{ data.msg1 | translate }}
        } @if(data.prevMonth){
        <span>{{ data.prevMonth | translate }}</span>
        } @if(data.prevYear){
        <span> {{ data.prevYear }}</span>
        } @if(data.msg2){
        {{ data.msg2 | translate }}
        }
      </p>
      <p>
        {{ data.message2 | translate }}
      </p>
    </mat-dialog-content>
  </div>
  <mat-dialog-actions class="orgApp-promt-dialog-action">
    <button
      class="orgApp-prompt-cancel-btn orgApp-prompt-btn orgApp-btn-width"
      mat-stroked-button
      (click)="onButtonClick(data.buttonName[0])"
    >
      {{ data.buttons[0] | translate }}
    </button>
    @if(data?.buttons[1]){<button
      mat-raised-button
      class="orgApp-prompt-save-btn orgApp-prompt-btn orgApp-btn-width"
      (click)="onButtonClick(data.buttonName[1])"
    >
      {{ data.buttons[1] | translate }}</button
    >}
  </mat-dialog-actions>
</div>
